(function ($) {

    /**
     * Get the current window width
     */
    function getWindowWidth() {
      return Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 );
    }

    /**
     * Set the scroll treshold
     */
    function setScrollNumberDesktop() {
      let defaultScroll = 325;
      if ($(document.body).hasClass('home') ) {
        // This is a home page so set the treshold to higher
        defaultScroll = 600;
      }
      return defaultScroll;
    }

    var windowWidth = getWindowWidth();
    var scrollNumberdesktop = setScrollNumberDesktop();

    /**
     * Run the function should users resize their window.
     */
    window.addEventListener( 'resize', function() {
      windowWidth = getWindowWidth();
    }, true);
    
    $( window ).scroll( function() {

        // Mobile
        if( windowWidth <= 959 && $( this ).scrollTop() > 64 ) {
          if( !$( '.header-section' ).hasClass( 'sticky' ) ) {
            $( '.header-section' ).addClass( 'sticky' );
          }
        }
        // Desktop
        else if( windowWidth >= 960 && $( this ).scrollTop() > scrollNumberdesktop ) {
          if( !$( '.header-section' ).hasClass( 'sticky' ) ) {
            $( '.header-section' ).addClass( 'sticky' );
          }
        } else {
          if( $( '.header-section' ).hasClass( 'sticky' ) ) {
            $( '.header-section' ).removeClass( 'sticky' );
          }
        }
    } );
    
})(jQuery);